import { render, staticRenderFns } from "./master-add.vue?vue&type=template&id=16a73106&scoped=true"
import script from "./master-add.vue?vue&type=script&lang=js"
export * from "./master-add.vue?vue&type=script&lang=js"
import style0 from "./master-add.vue?vue&type=style&index=0&id=16a73106&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16a73106",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/data/workspace/KCC_AUDIT_PROD_Frontend/node_modules/vue-loader/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16a73106')) {
      api.createRecord('16a73106', component.options)
    } else {
      api.reload('16a73106', component.options)
    }
    module.hot.accept("./master-add.vue?vue&type=template&id=16a73106&scoped=true", function () {
      api.rerender('16a73106', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/master-data/master-add.vue"
export default component.exports